export const LOGIN = '/api/authenticate';

export const ACCOUNT = '/api/account';
export const ACCOUNT_CHANGE_PASSWORD = '/api/account/change-password';

export const PUBLIC_TENANTS_BY_CHAIN = '/api/public/tenants/by-chain';

export const SHIFT = '/api/shifts';

export const ADMIN_USER = '/api/admin/users';

export const USER = '/api/users';
export const PERMISSION_FEATURE = 'api/permissions/features';
export const PERMISSION_AUTHORITY = 'api/permissions/authorities';
export const PERMISSION_USER = 'api/permissions/users';
export const AUTHORITY = 'api/authorities';

export const CUSTOMER = '/api/customers';
export const CUSTOMER_DEBT_REPORT = '/api/reports/debt-report';
export const DEBT_REPORT_EXPORT = '/api/reports/debt-report/export';
export const ORDER_LIST_EXPORT = '/api/reports/order-list/export';
export const PAYMENT_LIST_EXPORT = '/api/reports/payment-list/export';

export const CUSTOMER_OBJECT = '/api/customer-objects';

export const S3_PRESIGN_UPLOAD = 'api/s3/presign/upload';

export const S3_PRESIGN_DOWNLOAD = 'api/s3/presign/download';

export const S3_PRESIGN_DOWNLOAD_BATCH = 'api/s3/presign/download/batch';

export const ORDER = 'api/orders';

export const SERVICE = 'api/services';
export const SERVICE_BATCH_PRICE = 'api/services/batch-price';

export const SERVICE_CATEGORY = 'api/service-categories';

export const CUSTOMER_VOUCHER = 'api/customer-object-vouchers';
export const CUSTOMER_VOUCHER_USE = 'api/customer-object-vouchers/use';
export const CUSTOMER_OBJECT_VOUCHER_TXN = 'api/customer-object-voucher-txns';

export const PUBLIC_CUSTOMER_VOUCHER = 'api/public/customer-object-vouchers/customer-overview';

export const RECEIPT = 'api/receipts';
export const RECEIPT_PAYMENT_REPORT = 'api/receipts/payment-report';

export const EXPENSE_CATEGORY = 'api/expense-categories';
export const EXPENSE_VOUCHER = 'api/expense-vouchers';
export const PRODUCT_CATEGORY = 'api/product-categories';
export const PRODUCT = 'api/products';
export const INVENTORY_DOC = 'api/inventory-docs';
export const INVENTORY_STOCK_REPORT = '/api/reports/stock-report';
export const STOCK_REPORT_EXPORT = '/api/reports/stock-report/export';
export const STOCK_REPORT_EXPORT_DETAIL = '/api/reports/stock-report/export-detail';

export const PUMP = 'api/pumps';
export const AUDIT_LOG = 'api/audit';
